import { render, staticRenderFns } from "./CheckoutApproved.vue?vue&type=template&id=beccc68a"
import script from "./CheckoutApproved.vue?vue&type=script&lang=js"
export * from "./CheckoutApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports